import React, {Component} from "react";
import { Link } from "react-router-dom";
import { LocalDataSetup } from "pouchDB/LocalDataSetup";
// reactstrap components
import { Card, CardFooter, CardHeader, CardBody, Row, Col, CardTitle ,Collapse, Table} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";

class EngineerDiary extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            openedCollapses: ["collapseOne"],
            jobResults: [],
            filteredJobs: [],
            weekCommencing: '',
            weekCommencing_text: '',
            dayName: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        };
    }

    async componentDidMount() {
        //set weekcommencing to the date last monday
        let today = new Date();
        let day = today.getDay();
        //eslint-disable-next-line
        let diff = today.getDate() - day + (day == 0 ? -6:1);
        let lastMonday = new Date(today.setDate(diff));
        let weekCommencing = lastMonday.toISOString().split('T')[0];

        this.setState({weekCommencing: weekCommencing});

        await this.loadAllJobs().then((jobs) => {
            console.log('initial filtered jobs');
            //get all jobs from jobResults and filter them by any visitdate within then and the next 6 days. Then save in filteredJobs
            let weekCommencing = new Date(this.state.weekCommencing);
            let nextWeek = new Date(weekCommencing);
            nextWeek.setDate(nextWeek.getDate() + 6);

            let filteredJobs = jobs.filter(job => {
                let visitDate = new Date(job.doc.job.VisitDate);
            
                if(visitDate >= weekCommencing && visitDate <= nextWeek){
                    return job;
                }
                else {
                    return null;
                }
            });

            this.setState({filteredJobs: filteredJobs});
        });
    }

    filterJobs = () => {   
        console.log('filtering jobs');
        //get all jobs from jobResults and filter them by any visitdate within then and the next 6 days. Then save in filteredJobs
        let jobs = this.state.jobResults;
        let weekCommencing = new Date(this.state.weekCommencing);
        let nextWeek = new Date(weekCommencing);
        nextWeek.setDate(nextWeek.getDate() + 6);

        console.log(weekCommencing);
        console.log(nextWeek);

        let filteredJobs = jobs.filter(job => {
            let visitDate = new Date(job.doc.job.VisitDate);
        
            if(visitDate >= weekCommencing && visitDate <= nextWeek){
                return job;
            }
            else {
                return null;
            }
        });

        this.setState({filteredJobs: filteredJobs});
    }

    //listen for state weekcommencing change and filter jobs
    componentDidUpdate(prevProps, prevState) {
        if (this.state.weekCommencing !== prevState.weekCommencing) {
            this.filterJobs();
        }
    }

    loadAllJobs = async () => { 
        let db_jobs_local = LocalDataSetup.db_jobs_local;
        let jobs = await db_jobs_local.allDocs({
            include_docs: true
        });

        jobs.rows = jobs.rows.filter(row => {
            let subcon_ids = sessionStorage.getItem('subcon_id');
            subcon_ids = subcon_ids.split(',');
            if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                return row; // Filter for jobs that belong to the subcontractor
            }
            else {
                return null;
            }
        });

        this.setState({ jobResults: jobs.rows });
        return jobs.rows;
    }

    collapsesToggle = (collapse) => {
        if (this.state.openedCollapses.includes(collapse)) {
          this.setOpenCollapses([]);
        } else {
          this.setOpenCollapses([collapse]);
        }
    };

    setOpenCollapses = (collapse) => {
        this.setState({
            openedCollapses: collapse,
        });
    }

    render() {

        return (
        <>
            <PanelHeader
                size="lg"
                content={image}
            />
            <div className="content" style={{marginTop: '-40px'}}>
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                        <CardHeader>
                            {/* <h5 className="card-category">Stats / Other Bits</h5> */}
                            <CardTitle tag="h4" className="card-category">Week Commencing - { this.state.weekCommencing.split('-').reverse().join('/') }</CardTitle>
                        </CardHeader>
                        <CardBody>
                            <center>
                                <button 
                                className="btn btn-primary btn-round"
                                onClick={() => {
                                    let weekCommencing = new Date(this.state.weekCommencing);

                                    weekCommencing.setDate(weekCommencing.getDate() - 7);
                                    this.setState({weekCommencing: weekCommencing.toISOString().split('T')[0]});
                                    // this.filterJobs();
                                }}>Previous Week</button>
                                <button 
                                className="btn btn-primary btn-round"
                                onClick={() => {
                                    let weekCommencing = new Date(this.state.weekCommencing);

                                    weekCommencing.setDate(weekCommencing.getDate() + 7);
                                    this.setState({weekCommencing: weekCommencing.toISOString().split('T')[0]})
                                    // this.filterJobs();
                                }}>Next Week</button>
                            </center>
                        <div
                            aria-multiselectable={true}
                            className="card-collapse"
                            id="accordion"
                            role="tablist"
                        >
                        {
                            // iterate through dayName and for each day group into collapsible
                            this.state.dayName.map((day, index) => {
                                let collapseId = 'collapse' + index;
                                // let dayOfWeekText = this.state.weekCommencing.split('-').reverse().join('/') + ' - ' + day;

                                // if collapse already exists then skip it
                                return (
                                    <Card className="card-plain" key={index}>
                                        <CardHeader role="tab">
                                        <a
                                            aria-expanded={this.state.openedCollapses.includes(collapseId)}
                                            href="#p"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={(e) => {
                                            e.preventDefault();
                                            this.collapsesToggle(collapseId);
                                            }}
                                        >
                                            {day}
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                        </a>
                                        </CardHeader>
                                        <Collapse
                                        role="tabpanel"
                                        isOpen={this.state.openedCollapses.includes(collapseId)}
                                        >
                                        <CardBody>
                                            <Table>
                                                <thead className="jcwMainColour">
                                                    <th>Job</th>
                                                    <th>Site</th>
                                                    <th>Status</th>
                                                    <th>Description</th>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.filteredJobs.sort((a, b) => {
                                                            //sort by VisitDate descending
                                                            return new Date(a.doc.job.VisitDate) - new Date(b.doc.job.VisitDate);
                                                        }).map((job, index) => {
                                                            let visitDate = new Date(job.doc.job.VisitDate);
                                                            let dayOfWeek = visitDate.toLocaleDateString('en-US', { weekday: 'long' });

                                                            if(dayOfWeek === day){
                                                                return (
                                                                    <Link key={index} className="table-row" to={`/admin/jobsearch/${'none'}/${job.doc.job.JobID+'*'+job.doc.job.SessionID}`}>
                                                                        <td>{job.doc.job.JobID}</td>
                                                                        <td>{job.doc.job.Name}</td>
                                                                        <td>{job.doc.job.StatusDesc}</td>
                                                                        <td>{job.doc.job.ToDo.substring(0, 25)}...</td>
                                                                    </Link>
                                                                );
                                                            }
                                                            else {
                                                                return null;
                                                            }
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                        </CardBody>
                                        </Collapse>
                                    </Card>
                                );
                            })
                        }
                    </div>
                    </CardBody>
                    <CardFooter>

                    </CardFooter>
                    </Card>
                </Col>
            </Row>
            </div>
        </>
        );
    }
}

export default EngineerDiary;